import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getTrashBinList, restoreTrashBinItem, viewTrashBinItem } from "store/services/trashBinService";

// Get all trashbin items
export const useGetTrashBinItems = (params, options = {}) => {
  return useQuery({
    queryKey: ["trashBinItems", params],
    queryFn: () => getTrashBinList(params),
    ...options,
  });
};

// Restore Item
export const useRestoreItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: restoreTrashBinItem,
    onSuccess: (data, id) => {
      // Update cache for this product
      queryClient.invalidateQueries({ queryKey: ["trashBinItem", id] });
      queryClient.invalidateQueries({ queryKey: ["trashBinItems"] });
    },
  });
};


// Get single trash bin item by ID
export const useGetTrashBinItem = (id, options = {}) => {
  return useQuery({
    queryKey: ["trashBinItem", id],
    queryFn: () => viewTrashBinItem(id),
    enabled: !!id,
    ...options,
  });
};

// // Create product
// export const useCreateProduct = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: createProduct,
//     onSuccess: () => {
//       // Refetch the products list after creation
//       queryClient.invalidateQueries({ queryKey: ["products"] });
//     },
//   });
// };

// // Get all conditions
// export const useGetConditions = (params, options = {}) => {
//   return useQuery({
//     queryKey: ["conditions", params],
//     queryFn: () => getConditions(params),
//     ...options,
//   });
// };

// // Get all questions
// export const useGetQuestions = (params, options = {}) => {
//   return useQuery({
//     queryKey: ["questions", params],
//     queryFn: () => getQuestions(params),
//     ...options,
//   });
// };

// // Get all mappings
// export const useGetMappings = (params, options = {}) => {
//   console.log("params", params);
//   return useQuery({
//     queryKey: ["mappings", params],
//     queryFn: () => getMappings(params),
//     ...options,
//   });
// };

// // Create mapping
// export const useCreateMapping = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: createMapping,
//     onSuccess: () => {
//       // Refetch the mappings list after creation
//       queryClient.invalidateQueries({ queryKey: ["mappings"] });
//     },
//   });
// };

// // Update mapping
// export const useUpdateMapping = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: updateMapping,
//     onSuccess: (data, variables) => {
//       // Update cache
//       queryClient.invalidateQueries({ queryKey: ["mappings"] });
//     },
//   });
// };

// // Delete mapping
// export const useDeleteMapping = () => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: deleteMapping,
//     onSuccess: () => {
//       // Update cache
//       queryClient.invalidateQueries({ queryKey: ["mappings"] });
//     },
//   });
// };